import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { PostClubProfilePaymentsParams } from '@/shared/api/requests/club/payments/post/request';
import { postClubProfilePayments } from '@/shared/api/requests/club/payments/post/request';

export const useClubProfilePaymentsMutation = (
  settings?: MutationSettings<
    PostClubProfilePaymentsParams,
    typeof postClubProfilePayments
  >
) =>
  useMutation({
    mutationKey: ['ClubProfilePayments'],
    mutationFn: ({ params, config }) =>
      postClubProfilePayments({
        params,
        config
      }),
    ...settings?.options
  });
